import { LogicType_DeltaIn, LogicType_DeltaPercentageIn, LogicType_In } from '../atom-case-operator/index.js';
export const AllInOperators = [LogicType_DeltaIn, LogicType_DeltaPercentageIn, LogicType_In];
//# sourceMappingURL=consts.js.map